<template>
    <div class="history">
        <el-tooltip effect="dark" content="Cofnij ostatnią zmianę w projekcie" placement="bottom">
            <el-link :underline="false" icon="el-icon-arrow-left" @click="handleUndo">
                Cofnij
            </el-link>
        </el-tooltip>
        <el-tooltip effect="dark" content="Powtórz ostatnią zmianę w projekcie" placement="bottom">
            <el-link class="redo" :underline="false" @click="handleRedo">
                Powtórz <i class="el-icon-arrow-right"></i>
            </el-link>
        </el-tooltip>
    </div>
</template>

<script>
import Editor from '../../../classes/Editor'

export default {
    methods: {
        handleUndo() {
            Editor.canvas.undo();
        },
        handleRedo() {
            Editor.canvas.redo();
        },
    },
}
</script>

<style scoped>
.history {
    border-right: 1px solid #eaeaea;
    padding-right: 20px;
}

.redo {
    margin-left: 30px;
}

.el-link,
.el-link.el-link--primary {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
}
</style>